// extracted by mini-css-extract-plugin
export default {"root":"Bl+Cs","copyright":"XUZpP","social":"_6Kltz","bluesky":"zYRU6","linkedin":"rPNRE"};